<template>
    <ContentWrapperControl class="mt-4">
        <SettingCardControl v-bind:title="lang('lbl_0000131')">
            <SettingCardItemControl v-show="!$store.state.login" 
                v-bind:title="lang('lbl_0000001')" 
                href="/forgot-password"
                icon="papsi_help_forgot.svg" />
            <SettingCardItemControl v-bind:title="lang('lbl_0000132')"
                href="/contact-us"
                icon="papsi_help_contact.svg"
                :show_border="false" />
        </SettingCardControl>
        <!-- <SettingCardControl v-bind:title="lang('lbl_0000134')">
            <SettingCardItemControl v-bind:title="lang('lbl_0000133')" 
                href="/end-user-license-agreement"
                icon="papsi_handshake.svg" />
            <SettingCardItemControl v-bind:title="lang('lbl_0000135')" 
                href="/privacy-policy"
                icon="papsi_help_privacy.svg"
                :show_border="false" />
        </SettingCardControl> -->
    </ContentWrapperControl>
</template>

<script>
import ContentWrapperControl from './../components/controls/ContentWrapperControl.vue';
import SettingCardControl from './../components/controls/SettingCardControl.vue';
import SettingCardItemControl from './../components/controls/SettingCardItemControl.vue';
import mixin from './../mixin.js';

export default {
    mixins: [
        mixin,
    ],
    components: {
        ContentWrapperControl,
        SettingCardControl,
        SettingCardItemControl,
    },
    mounted() {
        this.$emit('shownavbar', {
            title: this.lang('lbl_0000130'),
            show: true,
            back: true,
        });
        this.$emit('nofooter', false);
    },
}
</script>